// What Song Studio accepts. Kept in its own module so the drop zone and the
// upload modal share one definition (and tests can mock the modal alone).

/** Song Studio takes rehearsal recordings only. */
export const STUDIO_ACCEPT = '.mp3,.wav,.m4a,audio/mpeg,audio/wav,audio/x-wav,audio/x-m4a,audio/mp4';
export const isStudioAudio = (file: File) => /\.(mp3|wav|m4a)$/i.test(file.name);
export const STUDIO_FORMAT_ERROR = 'Song Studio takes MP3, WAV or M4A recordings.';

// Fall back to the file name (without extension) when no title is entered.
export const deriveTitle = (fileName: string) => fileName.replace(/\.[^/.]+$/, '').trim() || 'Untitled song';
